module.exports = __webpack_public_path__ + "img/icon_footer_close.931b2fb3.png";